import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.array.flat-map";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.find";
import _union from "lodash/union";
import _flatMap from "lodash/flatMap";
import _compact from "lodash/compact";
import _difference from "lodash/difference";
import _intersection from "lodash/intersection";
import _concat from "lodash/concat";
import _slice from "lodash/slice";
import _isNil from "lodash/isNil";
import _reverse from "lodash/reverse";
import _round from "lodash/round";
import _max from "lodash/max";
import _pick from "lodash/pick";
import _isEmpty from "lodash/isEmpty";
import _uniq from "lodash/uniq";
import _isEqual from "lodash/isEqual";
import _each from "lodash/each";
import _uniqBy from "lodash/uniqBy";
import _assign from "lodash/assign";
import _groupBy from "lodash/groupBy";
import _filter from "lodash/filter";
import _reduce from "lodash/reduce";
import _sortBy from "lodash/sortBy";
import _map from "lodash/map";
import _toString from "lodash/toString";
import _findIndex from "lodash/findIndex";
import _includes from "lodash/includes";
import _some from "lodash/some";
import _find from "lodash/find";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import moment from 'moment';
import { createSelector } from 'reselect';
import { CURRENT_YODLEE_TOS_VERSION, CashFlowCategories, CustomProviderIconsById, DATE_FORMAT, ProviderAccountErrorPriorities, ProviderAccountState, TransactionCategories, TransactionCategoriesV2, UserPreferredIncomeEstimateSources, YodleeAccountSubTypes, YodleeAccountTypes, YodleeBankAccountType, genericIconsByYodleeAccountType } from "../../constants";
import { FINANCIAL_PORTAL_PRIMARY_SOURCES } from "../../constants/account-aggregation";
import * as yodleeUtils from "../../utils/yodlee"; // ******* Basic ******
// these selectors are in profiles but because of a circular dependency issue that causes
// mobile Jest tests to break, we redefine them here.

var getIncome = function getIncome(identity) {
  return _get(identity, 'profiles.financial_profile.annual_income');
};

var getMonthlyNetIncome = function getMonthlyNetIncome(identity) {
  return _get(identity, 'profiles.financial_profile.monthly_net_income');
};

var getUserPreferredIncomeEstimateSource = function getUserPreferredIncomeEstimateSource(identity) {
  return _get(identity, 'profiles.financial_profile.user_preferred_income_source');
};

export var getAllProviderAccounts = function getAllProviderAccounts(identity) {
  return _get(identity, 'profiles.yodlee_profile.provider_accounts', []);
};
export var getAllProviderAccountsPure = function getAllProviderAccountsPure(identity) {
  return _get(identity, 'profiles.yodlee_profile.provider_accounts');
};
export var getSelectedInstitutionId = function getSelectedInstitutionId(identity) {
  var _identity$yodlee, _identity$yodlee$onbo, _identity$yodlee$onbo2, _identity$yodlee2, _identity$yodlee2$onb;

  return (identity === null || identity === void 0 ? void 0 : (_identity$yodlee = identity.yodlee) === null || _identity$yodlee === void 0 ? void 0 : (_identity$yodlee$onbo = _identity$yodlee.onboarding) === null || _identity$yodlee$onbo === void 0 ? void 0 : (_identity$yodlee$onbo2 = _identity$yodlee$onbo.selectedProvider) === null || _identity$yodlee$onbo2 === void 0 ? void 0 : _identity$yodlee$onbo2.id) || (identity === null || identity === void 0 ? void 0 : (_identity$yodlee2 = identity.yodlee) === null || _identity$yodlee2 === void 0 ? void 0 : (_identity$yodlee2$onb = _identity$yodlee2.onboarding) === null || _identity$yodlee2$onb === void 0 ? void 0 : _identity$yodlee2$onb.selectedProviderId);
}; // Get the current selected provider ID (this would usually be set from the provider search step).

export var getSelectedProviderId = function getSelectedProviderId(identity) {
  return _get(identity, 'yodlee.onboarding.selectedProviderId');
}; // More details about the selected provider, since search results are not stored in redux for FDP

export var getSelectedProvider = function getSelectedProvider(identity) {
  return _get(identity, 'yodlee.onboarding.selectedProvider');
}; // Get the current selected provider account ID. Note: this is different than provider ID. It's
// possible to multiple provider accounts (and hence provider account IDs) for a single provider ID.

export var getSelectedProviderAccountId = function getSelectedProviderAccountId(identity) {
  return _get(identity, 'yodlee.onboarding.selectedProviderAccountId');
}; // get currently selected top provider type if any

export var getTopProviderType = function getTopProviderType(identity) {
  return _get(identity, 'yodlee.onboarding.topProviderType');
}; // Get flag denoting whether preliminary error screens can be skipped

export var getShouldSkipErrorScreen = function getShouldSkipErrorScreen(identity) {
  return _get(identity, 'yodlee.onboarding.shouldSkipErrorScreen');
};
export var getIdfromProviderAccount = function getIdfromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider_account_id');
};
export var getProviderIdfromProviderAccount = function getProviderIdfromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider_id');
};
export var getProviderAccountStateIdFromProviderAccount = function getProviderAccountStateIdFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.id');
};
export var getStateFromProviderAccount = function getStateFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.state');
};
export var getStatusCodeFromProviderAccount = function getStatusCodeFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.status_code');
};
export var getStatusMessageFromProviderAccount = function getStatusMessageFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.status_message');
};
export var getNameFromProviderAccount = function getNameFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.name');
};
export var getFaviconFromProviderAccount = function getFaviconFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.favicon');
};
export var getLogoFromProviderAccount = function getLogoFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.logo');
};
export var getStateSetAtFromProviderAccount = function getStateSetAtFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.state_set_at');
};
export var getLoginUrlFromProviderAccount = function getLoginUrlFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.login_url');
};
export var getBankUrlFromProviderAccount = function getBankUrlFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.provider_details.baseUrl');
};
export var getPrimaryErrorActionFromProviderAccount = function getPrimaryErrorActionFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.error_resolutions.primary_action');
};
export var getSecondaryErrorActionFromProviderAccount = function getSecondaryErrorActionFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.error_resolutions.secondary_action');
};

var getDateFromProps = function getDateFromProps(state, props) {
  return _get(props, 'date');
};

var getStartDateFromProps = function getStartDateFromProps(state, props) {
  return _get(props, 'startDate');
};

var getEndDateFromProps = function getEndDateFromProps(state, props) {
  return _get(props, 'endDate');
};

export var getInvestingAccountType = function getInvestingAccountType(providerAccount) {
  return _get(providerAccount, 'extra_data.investingAccountType');
};
export var hasProviderAccounts = function hasProviderAccounts(identity) {
  return !!getAllProviderAccounts(identity).length;
};
export var getGenericIconForAccountType = function getGenericIconForAccountType(accountType) {
  return genericIconsByYodleeAccountType[accountType] || genericIconsByYodleeAccountType[YodleeAccountTypes.BANK];
};
export var getCustomIconForProviderId = function getCustomIconForProviderId(id) {
  return CustomProviderIconsById[id];
};
export var getCustomIconForProviderAccount = function getCustomIconForProviderAccount(providerAccount) {
  var providerId = getProviderIdfromProviderAccount(providerAccount);
  return CustomProviderIconsById[providerId];
};
export var getCustomOrGenericIconForAccount = function getCustomOrGenericIconForAccount(providerAccount, accountType) {
  return getCustomIconForProviderAccount(providerAccount) || getGenericIconForAccountType(accountType);
};
export var getBestIconFromProviderAccount = function getBestIconFromProviderAccount(providerAccount, accountType) {
  var customIcon = getCustomIconForProviderAccount(providerAccount);
  var favicon = getFaviconFromProviderAccount(providerAccount);
  return customIcon || favicon || getGenericIconForAccountType(accountType);
};
export var getBestImageFromProviderAccount = function getBestImageFromProviderAccount(providerAccount) {
  var logo = getLogoFromProviderAccount(providerAccount);
  var favicon = getFaviconFromProviderAccount(providerAccount);

  if (logo) {
    return logo;
  }

  return favicon;
};
/**
 * Given a Yodlee-shaped Provider Account or FDP Portal, get the best icon to display for that institution. Trusts
 * favicons from Plaid institutions, but not Yodlee (preferring a manually-curated list or default icons instead).
 *
 * @param {Object} providerAccount - the provider account to get the icon of
 * @param {Object} accountType - the type of account the provider falls under (e.g. 'bank')
 * @returns {string} - the icon to use for the provider account
 */

export var getBestOrGenericIconForProviderAccount = function getBestOrGenericIconForProviderAccount(providerAccount, accountType) {
  var isPlaidAccount = yodleeUtils.getPrimarySourceFromProviderAccount(providerAccount) === FINANCIAL_PORTAL_PRIMARY_SOURCES.PLAID;
  return isPlaidAccount ? getBestIconFromProviderAccount(providerAccount, accountType) : getCustomOrGenericIconForAccount(providerAccount, accountType);
};
/**
 *
 * @param {object} identity
 * @param {string} accountId - financial account id (not provider account id)
 * @returns {string} the icon url of the provider account to which this account ID belongs
 */

export var getBestProviderAccountIconByAccountId = function getBestProviderAccountIconByAccountId(identity, accountId) {
  var providerAccounts = getAllProviderAccounts(identity);

  var providerAccount = _find(providerAccounts, function (x) {
    return _some(x.accounts, function (account) {
      return account.id === accountId;
    });
  });

  return getBestIconFromProviderAccount(providerAccount);
};
export var getMfaFormFromProviderAccount = function getMfaFormFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.mfa_form', null);
};
export var getMfaTypeFromProviderAccount = function getMfaTypeFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.mfa_form.formType', null);
};
export var hasAuthenticatedProviderAccount = function hasAuthenticatedProviderAccount(identity) {
  var providerAccounts = getAllProviderAccounts(identity);
  var authenticatedStates = [ProviderAccountState.AUTHENTICATED, ProviderAccountState.ACTIVE];
  return _some(providerAccounts, function (providerAccount) {
    var state = getStateFromProviderAccount(providerAccount);
    return _includes(authenticatedStates, state);
  });
};
export var getProviderAccountById = function getProviderAccountById(identity, id) {
  var providerAccounts = getAllProviderAccounts(identity);
  return _find(providerAccounts, function (account) {
    return getIdfromProviderAccount(account) === id;
  });
};
/**
 * Given an id, fetches the associated provider account from the Yodlee slice of the redux store
 * (NOT from yodlee_profile)
 */

export var getOnboardingProviderAccountById = function getOnboardingProviderAccountById(identity, id) {
  var _identity$yodlee$onbo3;

  return (_identity$yodlee$onbo3 = identity.yodlee.onboarding.providerAccounts) === null || _identity$yodlee$onbo3 === void 0 ? void 0 : _identity$yodlee$onbo3.find(function (pa) {
    var _pa$provider_account_;

    return +(pa === null || pa === void 0 ? void 0 : (_pa$provider_account_ = pa.provider_account_state) === null || _pa$provider_account_ === void 0 ? void 0 : _pa$provider_account_.provider_account_id) === +id;
  });
};
export var getOnboardingProviderAccountByProviderId = function getOnboardingProviderAccountByProviderId(identity, id) {
  return _find(identity.yodlee.onboarding.providerAccounts, function (pa) {
    return getProviderIdfromProviderAccount(pa) === +id;
  });
};
export var getProviderAccountByProviderId = function getProviderAccountByProviderId(identity, id) {
  var providerAccounts = getAllProviderAccounts(identity);
  return _find(providerAccounts, function (account) {
    return getProviderIdfromProviderAccount(account) === id;
  });
};
export var getProviderAccountByProviderAccountStateId = function getProviderAccountByProviderAccountStateId(identity, id) {
  var providerAccounts = getAllProviderAccounts(identity);
  return _find(providerAccounts, function (account) {
    return getProviderAccountStateIdFromProviderAccount(account) === id;
  });
}; // Get the provider for the current selected provider ID

export var getSelectedProviderByProviderId = function getSelectedProviderByProviderId(identity) {
  var selectedProviderId = getSelectedProviderId(identity);
  if (!selectedProviderId) return;
  return getProviderAccountByProviderId(identity, selectedProviderId);
};
export var getSelectedProviderStatusCode = function getSelectedProviderStatusCode(identity) {
  var selectedProvider = getSelectedProviderByProviderId(identity);
  return getStatusCodeFromProviderAccount(selectedProvider);
}; // Get the provider account for the current selected provider account ID

export var getSelectedProviderAccount = function getSelectedProviderAccount(identity) {
  var selectedProviderAccountId = getSelectedProviderAccountId(identity);
  if (!selectedProviderAccountId) return;
  return getOnboardingProviderAccountById(identity, selectedProviderAccountId);
};
export var getSelectedProviderAccountByProviderId = function getSelectedProviderAccountByProviderId(identity) {
  var selectedProviderId = getSelectedProviderId(identity);
  if (!selectedProviderId) return;
  return getOnboardingProviderAccountByProviderId(identity, selectedProviderId);
};
export var getProviderAccountStateById = function getProviderAccountStateById(identity, id) {
  var providerAccount = getProviderAccountById(identity, id);
  return getStateFromProviderAccount(providerAccount);
};
export var getSelectedProviderAccountState = function getSelectedProviderAccountState(identity) {
  var selectedProviderAccount = getSelectedProviderAccount(identity);
  return getStateFromProviderAccount(selectedProviderAccount);
};
export var getSelectedProviderAccountStatusCode = function getSelectedProviderAccountStatusCode(identity) {
  var selectedProviderAccount = getSelectedProviderAccount(identity);
  return getStatusCodeFromProviderAccount(selectedProviderAccount);
};
export var getPreviousSelectedProviderAccountState = function getPreviousSelectedProviderAccountState(identity) {
  var selectedProviderAccount = getSelectedProviderAccount(identity);
  return _get(selectedProviderAccount, 'provider_account_state.previous_state');
}; // Get the current account onboarding provider search query

export var getProviderSearchQuery = function getProviderSearchQuery(identity) {
  return _get(identity, 'yodlee.onboarding.searchQuery');
}; // export const getIsProviderLoginError = (identity) => {
//   const providerAccountState = getSelectedProviderAccountState(identity);
//   const previousProviderAccountState = getPreviousSelectedProviderAccountState(identity);
//   if (providerAccountState === ProviderAccountState.ERROR) {
//     // if previous state was LOGIN_IN_PROGRESS then assume it failed on login
//     if (previousProviderAccountState === ProviderAccountState.LOGIN_IN_PROGRESS) return true;
//     // if no previous provider account state it went straight to error on the login call
//     if (typeof previousProviderAccountState === 'undefined') return true;
//   }
//   return false;
// };
// export const getIsProviderMfaError = (identity) => {
//   const providerAccountState = getSelectedProviderAccountState(identity);
//   const previousProviderAccountState = getPreviousSelectedProviderAccountState(identity);
//   if (providerAccountState === ProviderAccountState.ERROR) {
//     if (previousProviderAccountState === ProviderAccountState.MFA_IN_PROGRESS) return true;
//     if (previousProviderAccountState === ProviderAccountState.MFA_REQUIRED) return true;
//     // if no previous provider account state it went straight to error on the login call
//     if (typeof previousProviderAccountState === 'undefined') return true;
//   }
//   return false;
// };
// Get boolean for whether there is a pending search request for the current provider
// search query.

export var getIsRequestPendingForQuery = function getIsRequestPendingForQuery(identity) {
  var query = getProviderSearchQuery(identity);
  return _some(identity.requests.searchProviders.pendingRequests, function (request) {
    return request.query === query;
  });
}; // Boolean whether provider details are being fetched for the currently selected
// external provider id. This should only be used for the Yodlee login flow.

export var getIsFetchingSelectedProviderDetails = function getIsFetchingSelectedProviderDetails(identity) {
  var providerId = getSelectedProviderId(identity);
  return _some(identity.requests.getProviderDetails.pendingRequests, function (request) {
    return request.providerId === providerId;
  });
}; // Get search results for current provider search query

export var getSearchResultsForQuery = function getSearchResultsForQuery(identity) {
  var query = getProviderSearchQuery(identity);
  return _get(identity, 'yodlee.searchResults', {})[query];
};
export var getHasSearchResultsForQuery = function getHasSearchResultsForQuery(identity) {
  return !!getSearchResultsForQuery(identity);
};
export var getIndexOfProviderIdInSearchResults = function getIndexOfProviderIdInSearchResults(identity, providerId) {
  var searchResults = getSearchResultsForQuery(identity) || [];
  return _findIndex(searchResults, function (result) {
    return result.id === providerId;
  });
}; // Get boolean for whether login is in progress for the selected provider id. Since the api is
// async it needs to check whether there is a pending request for the provider id or a provider
// account state of LOGIN_IN_PROGRESS. Should only use for the Yodlee flow.

export var getIsLoggingIntoSelectedProvider = function getIsLoggingIntoSelectedProvider(identity) {
  var providerId = getSelectedProviderId(identity);

  var hasPendingRequests = _some(identity.requests.loginToProvider.pendingRequests, // the id is an int for Yodlee but a string for Plaid so the field is defined as a string in query0
  // but is a number when from identity. The mixed linking flow switches between the two so we need to normalize the type
  function (request) {
    return _toString(request.providerId) === _toString(providerId);
  }); // if there is a pending request for same provider id assume they're logging into the provider


  if (hasPendingRequests) return true;
  var providerAccountState = getSelectedProviderAccountState(identity);
  if (!providerAccountState) return false;
  return providerAccountState === ProviderAccountState.LOGIN_IN_PROGRESS;
}; // Get boolean for whether mfa is in progress for the currently selected provider account id.
// Since the api is async it needs to check whether there is a pending request for the provider
// account id or a provider account state of MFA_IN_PROGRESS.

export var getIsAttemptingMFA = function getIsAttemptingMFA(identity) {
  var selectedProviderAccountId = getSelectedProviderAccountId(identity);

  var hasPendingRequests = _some(identity.requests.attemptProviderMFA.pendingRequests, function (request) {
    return request.providerAccountId === selectedProviderAccountId;
  });

  if (hasPendingRequests) return true;
  var providerAccountState = getSelectedProviderAccountState(identity);
  if (!providerAccountState) return false;
  return providerAccountState === ProviderAccountState.MFA_IN_PROGRESS;
};
export var getHasResultsForSearchQuery = function getHasResultsForSearchQuery(identity) {
  var query = getProviderSearchQuery(identity);

  var results = _get(identity, 'yodlee.searchResults', {});

  return !!results[query];
};
export var getIsSearchQueryValid = function getIsSearchQueryValid(identity) {
  var query = getProviderSearchQuery(identity);
  return typeof query === 'string' && query.length >= 3;
}; // Boolean whether to make an api request to search providers. Conditions: query must be valid, no
// cached results for the query, and no pending request for the query.

export var getShouldSearchProviders = function getShouldSearchProviders(identity) {
  var query = getProviderSearchQuery(identity);

  var pendingRequests = _get(identity, 'requests.searchProviders.pendingRequests');

  var hasPendingRequest = _some(pendingRequests, function (req) {
    return req.query === query;
  });

  return !hasPendingRequest && getIsSearchQueryValid(identity) && !getHasSearchResultsForQuery(identity);
};
export var getYodleeLoginFormState = function getYodleeLoginFormState(identity) {
  return _get(identity, 'yodlee.onboarding.loginForm');
};
export var getYodleeMfaFormState = function getYodleeMfaFormState(identity) {
  return _get(identity, 'yodlee.onboarding.mfaForm');
};
export var getYodleeFieldsArrayFromFormState = function getYodleeFieldsArrayFromFormState(formState) {
  var fields = _map(formState, function (value, id) {
    return {
      value: value,
      id: id
    };
  }); // We need to sort these fields in ascending order, otherwise Yodlee can blow up


  return _sortBy(fields, 'id');
};
export var getHasLinkedAccounts = function getHasLinkedAccounts(identity) {
  var hasActiveProviderAccount = _some(_get(identity, 'profiles.yodlee_profile.provider_accounts'), function (providerAccount) {
    /**
     * START: REMOVE ME BECAUSE I'M SUPER HACKY
     *
     * There is currently (7/13/2017) a bug in identity's Yodlee code. It causes the DAG accounts
     * to get stuck in `AUTHENTICATED` even when they're active accounts. This leads the transactions page
     * to not display anything. This fix looks for DAG accounts, and checks to see if they are either
     * `AUTHENTICATED` or `ACTIVE` instead of the correct logic of just checking for `ACTIVE`.
     */
    // Keeping this variable here so it's by all the code that will be removed later. I realize
    // it is unnecessarily getting redefined
    var listOfDagProviderIds = [16441, 16446, 16486];

    if (_includes(listOfDagProviderIds, _get(providerAccount, 'provider_account_state.provider.id'))) {
      return _includes([ProviderAccountState.ACTIVE, ProviderAccountState.AUTHENTICATED], _get(providerAccount, 'provider_account_state.state'));
    }
    /* END: REMOVE ME BECAUSE I'M SUPER HACKY */


    return _get(providerAccount, 'provider_account_state.state') === ProviderAccountState.ACTIVE;
  }); // It's possible that provider accounts can be ACTIVE, but have no underlying accounts.
  // We want to make sure the the user has at least one underlying account.


  var hasAnyAccounts = _some(_get(identity, 'profiles.yodlee_profile.provider_accounts'), function (providerAccount) {
    return _get(providerAccount, 'accounts.length') > 0;
  });

  return hasAnyAccounts && hasActiveProviderAccount;
};
export var getSyncedProviderAccounts = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  if (!providerAccounts) {
    return null;
  }

  return _reduce(providerAccounts, function (result, providerAccount) {
    return result.concat(_filter(providerAccount.accounts, function (account) {
      return !!account.transactions_last_synced_at;
    }));
  }, []);
});
export var getFailedAutoRefreshProviderAccountStateIds = function getFailedAutoRefreshProviderAccountStateIds(identity) {
  return _get(identity, 'yodlee.autoRefresh.failures');
};
export var getSyncedProviderAccountIds = createSelector([getSyncedProviderAccounts], function (providerAccounts) {
  return _map(providerAccounts, function (account) {
    return account.id;
  });
});
export var getHasSyncedTransactions = function getHasSyncedTransactions(identity) {
  return _some(_get(identity, 'profiles.yodlee_profile.provider_accounts'), function (providerAccount) {
    return _some(_get(providerAccount, 'accounts'), function (account) {
      return account.transactions_last_synced_at !== null;
    });
  });
};
export var getProviderTransactionsSyncing = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  return _filter(providerAccounts, function (providerAccount) {
    return _get(providerAccount, 'provider_account_state.state') === ProviderAccountState.ACTIVE && yodleeUtils.areProviderAccountTransactionsSyncing(providerAccount);
  });
});
export var getProviderAccountsSyncing = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  return _filter(providerAccounts, yodleeUtils.isProviderAccountSyncing);
});
export var getProviderAccountsRefreshing = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  return _filter(providerAccounts, yodleeUtils.isProviderAccountRefreshing);
});
export var getProviderAccountsNeedingAutoRefresh = createSelector([getAllProviderAccountsPure, getFailedAutoRefreshProviderAccountStateIds], function (providerAccounts, failedProviderAccountStateIdMap) {
  return _filter(providerAccounts, function (pa) {
    return !failedProviderAccountStateIdMap[pa.provider_account_state.id] && yodleeUtils.doesProviderAccountNeedAutoRefresh(pa);
  });
});
export var getProviderAccountsNeedingMfa = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  return _filter(providerAccounts, yodleeUtils.doesProviderAccountNeedMfa);
});
export var getProviderAccountsSyncingOrRefreshing = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  return _filter(providerAccounts, function (providerAccount) {
    return yodleeUtils.isProviderAccountSyncing(providerAccount) || yodleeUtils.isProviderAccountRefreshing(providerAccount);
  });
});
export var getProviderAccountsByState = function getProviderAccountsByState(identity, providerAccountState) {
  var providerAccounts = getAllProviderAccounts(identity);
  return providerAccounts.filter(function (account) {
    return _get(account, 'provider_account_state.state') === providerAccountState;
  });
};
export var getAllFinancialAccounts = createSelector([getAllProviderAccounts], function (providerAccounts) {
  return _reduce(providerAccounts, function (result, _ref) {
    var _ref$accounts = _ref.accounts,
        accounts = _ref$accounts === void 0 ? [] : _ref$accounts;
    return [].concat(_toConsumableArray(result), _toConsumableArray(accounts));
  }, []);
});
export var getAccountsGroupedByType = createSelector([getAllFinancialAccounts], function (accounts) {
  return _groupBy(accounts, 'yodlee_account_type');
});
export var getAccountsByType = function getAccountsByType(identity, type) {
  return _reduce(_get(identity, 'profiles.yodlee_profile.provider_accounts'), function (result, value) {
    return result.concat(_filter(value.accounts, {
      yodlee_account_type: type
    }));
  }, []);
};
/**
 * Returns all provider accounts from the yodlee_profile as a map of
 * [provider_id]: provider_account
 */

export var getAllProviderAccountsMappedToProviderId = createSelector([getAllProviderAccounts], function (providerAccounts) {
  return _reduce(providerAccounts, function (acc, providerAccount) {
    var _providerAccount$prov, _providerAccount$prov2;

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, (_providerAccount$prov = providerAccount.provider_account_state) === null || _providerAccount$prov === void 0 ? void 0 : (_providerAccount$prov2 = _providerAccount$prov.provider) === null || _providerAccount$prov2 === void 0 ? void 0 : _providerAccount$prov2.id, providerAccount));
  }, {});
}); // grab all accounts by type with custom square icons attached as customProviderIcon to each account

export var getAccountsByTypeWithCustomIcons = function getAccountsByTypeWithCustomIcons(identity, type) {
  return _reduce(_get(identity, 'profiles.yodlee_profile.provider_accounts'), function (result, providerAccount) {
    return result.concat(_map(_filter(providerAccount.accounts, {
      yodlee_account_type: type
    }), function (account) {
      return _assign(account, {
        customProviderIcon: getBestOrGenericIconForProviderAccount(providerAccount, type)
      });
    }));
  }, []);
};
export var getDebtAccounts = function getDebtAccounts(identity) {
  return [].concat(_toConsumableArray(getAccountsByType(identity, YodleeAccountTypes.CREDIT_CARD)), _toConsumableArray(getAccountsByType(identity, YodleeAccountTypes.LOAN)));
};
export var getAccountsForDebtAPI = function getAccountsForDebtAPI(accounts) {
  return accounts.map(function (account) {
    return _objectSpread(_objectSpread({}, account), {}, {
      extra_data: JSON.stringify(_get(account, 'extra_data'))
    });
  });
};
export var getHasDebtAccounts = function getHasDebtAccounts(identity) {
  return getDebtAccounts(identity).length > 0;
};
export var getRetirementAccounts = function getRetirementAccounts(identity) {
  return [].concat(_toConsumableArray(getAccountsByType(identity, YodleeAccountTypes.BANK)), _toConsumableArray(getAccountsByType(identity, YodleeAccountTypes.INVESTMENT)));
};
export var getHasRetirementAccounts = function getHasRetirementAccounts(identity) {
  return getRetirementAccounts(identity).length > 0;
};
export var getSavingsAccounts = function getSavingsAccounts(identity) {
  return getAccountsByType(identity, 'bank').filter(function (x) {
    return x.bank_account_type === YodleeBankAccountType.SAVINGS;
  });
};
export var getSavingsAccountsWithCustomIcons = function getSavingsAccountsWithCustomIcons(identity) {
  return getAccountsByTypeWithCustomIcons(identity, 'bank').filter(function (x) {
    return x.bank_account_type === YodleeBankAccountType.SAVINGS;
  });
};
export var getHasSavingsAccounts = function getHasSavingsAccounts(identity) {
  return getSavingsAccounts(identity).length > 0;
};
export var getHomeSavingsAccounts = function getHomeSavingsAccounts(identity) {
  return [].concat(_toConsumableArray(getSavingsAccountsWithCustomIcons(identity)), _toConsumableArray(getAccountsByTypeWithCustomIcons(identity, YodleeAccountTypes.INVESTMENT)));
};
export var getHasHomeSavingsAccounts = function getHasHomeSavingsAccounts(identity) {
  return getHomeSavingsAccounts(identity).length > 0;
};
export var getActiveProviderAccounts = function getActiveProviderAccounts(identity) {
  return getProviderAccountsByState(identity, ProviderAccountState.ACTIVE);
};
export var getReadyProviderAccounts = function getReadyProviderAccounts(identity) {
  return _filter(getProviderAccountsByState(identity, ProviderAccountState.ACTIVE), function (p) {
    return !_get(p, 'provider_account_state.is_active_sync') && !yodleeUtils.areProviderAccountTransactionsSyncing(p);
  });
};
/**
 * @deprecated Use @see {@link yodleeUtils.getIsProviderAccountError} instead.
 */

export var getIsProviderAccountError = function getIsProviderAccountError(providerAccount) {
  return yodleeUtils.getIsProviderAccountError(providerAccount);
};
export var getProviderAccountsWithErrors = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  return _filter(providerAccounts, getIsProviderAccountError);
});
export var getProviderAccountsWithHighPriorityErrors = createSelector([getProviderAccountsWithErrors], function (providerAccountsWithErrors) {
  return _filter(providerAccountsWithErrors, function (providerAccount) {
    return yodleeUtils.getProviderAccountErrorPriority(providerAccount) === ProviderAccountErrorPriorities.HIGH_PRIORITY;
  });
});
export var getProviderAccountsWithErrorsOrMfaRequired = createSelector([getProviderAccountsWithErrors, getProviderAccountsNeedingMfa], function (providerAccountsWithErrors, providerAccountsNeedingMfa) {
  return _uniqBy(providerAccountsWithErrors.concat(providerAccountsNeedingMfa), 'provider_account_state.id');
});
export var getProviderAccountsWithHighPriorityErrorsOrMfaRequired = createSelector([getProviderAccountsWithHighPriorityErrors, getProviderAccountsNeedingMfa], function (providerAccountsWithErrors, providerAccountsNeedingMfa) {
  return _uniqBy(providerAccountsWithErrors.concat(providerAccountsNeedingMfa), 'provider_account_state.id');
});
export var getLatestAccountRefreshTime = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  var latestTime;

  _each(providerAccounts, function (providerAccount) {
    _each(_get(providerAccount, 'accounts'), function (account) {
      var syncTime = account.last_refreshed && moment(account.last_refreshed);

      if (syncTime && (!latestTime || syncTime.isAfter(latestTime))) {
        latestTime = syncTime;
      }
    });
  });

  return latestTime;
});
export var getDaysSinceLastSync = function getDaysSinceLastSync(identity) {
  var latestTime = getLatestAccountRefreshTime(identity);
  return latestTime && Math.abs(latestTime.diff(moment(), 'days'));
};
export var getIsAnyAccountRefreshing = createSelector([getAllProviderAccountsPure], function (providerAccounts) {
  var isRefreshing = false;

  _each(providerAccounts, function (providerAccount) {
    isRefreshing = isRefreshing || yodleeUtils.isProviderAccountRefreshing(providerAccount);
  });

  return isRefreshing;
});
export var areTransactionsLoading = function areTransactionsLoading(identity) {
  return _get(identity, 'requests.getTransactions.hasPendingRequests');
};
export var getYodleeAccountById = function getYodleeAccountById(identity, id) {
  var result;

  var providerAccounts = _get(identity, 'profiles.yodlee_profile.provider_accounts');

  if (!providerAccounts || !providerAccounts.length) return;

  _each(providerAccounts, function (providerAccount) {
    var accounts = _get(providerAccount, 'accounts');

    if (!accounts || !accounts.length) return;

    _each(accounts, function (account) {
      if (account.id === id) {
        result = account;
      }
    });
  });

  return result;
};
export var isFinancialAccountHidden = function isFinancialAccountHidden(identity, id) {
  var account = getYodleeAccountById(identity, id);
  return !_get(account, 'nw_enabled');
};
export var getProviderAccountForAccount = function getProviderAccountForAccount(identity, account) {
  var result;

  var providerAccounts = _get(identity, 'profiles.yodlee_profile.provider_accounts');

  if (!providerAccounts || !providerAccounts.length) return;

  _each(providerAccounts, function (providerAccount) {
    var accounts = _get(providerAccount, 'accounts');

    if (!accounts || !accounts.length) return;

    _each(accounts, function (a) {
      if (account.id === a.id) {
        result = providerAccount;
      }
    });
  });

  return result;
};
export var getIsLoginFailed = function getIsLoginFailed(identity) {
  return getSelectedProviderAccountStatusCode(identity) === '402';
};
/**
 * Is this a login error due to bad user input and the user could try again?
 *
 * @param {Object} identity - Reducer state
 * @returns {?Object} If there is an error, returns an object containing
 * information about the error -- with either an `asyncError` or `yodleeError`
 * property.
 */

export var getYodleeOnboardingErrorState = function getYodleeOnboardingErrorState(identity) {
  var accountState = getSelectedProviderAccountState(identity);

  var asyncError = _get(identity, 'yodlee.onboarding.lastAsyncError');

  if (accountState === ProviderAccountState.ERROR) {
    var yodleeStatusCode = getSelectedProviderAccountStatusCode(identity);
    return {
      yodleeError: {
        statusCode: yodleeStatusCode,
        asyncError: asyncError
      }
    };
  }

  if (asyncError) {
    return {
      asyncError: asyncError
    };
  }

  return null;
};
/**
 * Is this a login error due to bad user input and the user could try again?
 *
 * @param {Object} errorState - Information about the error that occurred --
 * an object containing either an `asyncError` or `yodleeError` property.
 * @returns {Boolean}
 */

export var getIsYodleeLoginError = function getIsYodleeLoginError(errorState) {
  var asyncError = errorState.asyncError,
      yodleeError = errorState.yodleeError; // Yodlee invalid login status code

  if (_get(yodleeError, 'statusCode') === '402') {
    return true;
  } // Identity bad request http status code


  var httpStatusCode = _get(asyncError, 'error.resp.statusCode');

  if (httpStatusCode === 400 || httpStatusCode === 422) {
    return true;
  }

  var errorType = _get(asyncError, 'error.resp.body.error.type');

  if (errorType === 'TooManyRequestsError') {
    return true;
  }

  return false;
};
/**
 * Should the given error be shown via an inline error message? Otherwise, it
 * should be shown on a separate error screen.
 *
 * @param {Object} errorState - Information about the error that occurred --
 * an object containing either an `asyncError` or `yodleeError` property.
 * @returns {Boolean}
 */

export var getShouldShowYodleeErrorInline = function getShouldShowYodleeErrorInline(errorState) {
  return getIsYodleeLoginError(errorState);
};
export var getIsYodleeOnboardingMarkedAsComplete = function getIsYodleeOnboardingMarkedAsComplete(identity) {
  return _get(identity, 'yodlee.onboarding.isComplete', false);
};
export var isRollupRequestInProgress = function isRollupRequestInProgress(identity, month, filter) {
  var pendingRequests = _get(identity, 'requests.getTransactionsMonthCashFlow.pendingRequests');

  return _some(pendingRequests, function (r) {
    return r.meta.month === month && _isEqual(r.meta.filter, filter);
  });
};
export var getAreRollupRequestsPending = function getAreRollupRequestsPending(identity) {
  return _get(identity, 'requests.getTransactionsMonthCashFlow.hasPendingRequests');
};
export var getSumBankBalances = function getSumBankBalances(identity) {
  return _get(identity, 'profiles.yodlee_profile.sum_bank_balances');
};
export var getSumCreditCardBalances = function getSumCreditCardBalances(identity) {
  return (_get(identity, 'profiles.yodlee_profile.sum_credit_card_balances') || 0) * -1;
};
export var getSumDebts = function getSumDebts(identity) {
  return (_get(identity, 'profiles.yodlee_profile.sum_debts') || 0) * -1;
};
export var getSumInvestmentBalances = function getSumInvestmentBalances(identity) {
  return _get(identity, 'profiles.yodlee_profile.sum_investment_balances');
};
export var getTransactionData = function getTransactionData(identity) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var transactions = _get(identity, 'yodlee.transactions');

  return yodleeUtils.getTransactionData(transactions, filter);
};
export var getTransactionBuckets = function getTransactionBuckets(identity) {
  return _get(identity, 'yodlee.transactions.buckets');
};
/**
 * Returns a mapping of all transactions keyed by transaction ID
 *
 * @return {Object} Mapping of all transactions keyed by transaction ID
 */

export var getAllTransactionsById = function getAllTransactionsById(identity) {
  return _get(identity, 'yodlee.transactions.allTransactionsById');
};
/**
 * Returns an array of transactions across all buckets/filters.
 *
 * @return Array List of unique transactions
 */

export var getAllTransactions = createSelector([getAllTransactionsById], function (allTransactionsById) {
  return Object.values(allTransactionsById);
});

var getCanonicalMerchantNameFromProps = function getCanonicalMerchantNameFromProps(state, props) {
  return props.canonicalMerchantName;
};

var getTransactionIdFromProps = function getTransactionIdFromProps(state, props) {
  return props.transactionId;
};

export var getTransactionsToRecategorizeOnMerchantCategoryRule = createSelector([getAllTransactions, getTransactionIdFromProps, getCanonicalMerchantNameFromProps], function (transactions, transactionId, canonicalMerchantName) {
  return _filter(transactions, function (transaction) {
    return yodleeUtils.shouldUpdateTransactionCategoryForMerchantName(transaction, transactionId, canonicalMerchantName);
  });
});

var getCategoryFromProps = function getCategoryFromProps(state, props) {
  return props.category;
};

var getPreviousCategoryFromProps = function getPreviousCategoryFromProps(state, props) {
  return props.previousCategory;
};

export var getMonthsWithCategoriesForRollupsAfterMerchantCategoryRule = createSelector([getTransactionsToRecategorizeOnMerchantCategoryRule, getPreviousCategoryFromProps], function (transactions, previousCategory) {
  var needRollupsMap = {};

  _each(transactions, function (transaction) {
    var date = moment(transaction.date).date(1).format(DATE_FORMAT.STANDARD);

    var categories = _get(needRollupsMap, "".concat(date, ".categories"), [previousCategory]);

    categories.push(transaction.category);
    needRollupsMap[date] = _objectSpread(_objectSpread({}, needRollupsMap[date]), {}, {
      categories: _uniq(categories)
    });
  });

  return needRollupsMap;
});
/**
 * @returns {Object} in the following shape
 * {
 *   ...,
 *   [categoryKey]: {
 *     dayInStartMonth: YYYY-MM-DD,
 *     dayInEndMonth: YYYY-MM-DD,
 *   }
 * }
 *
 * where a categoryKey exists for every category that was touched by a recategorization
 * of a transaction
 */

export var getMonthsByCategoryForRollupsAfterMerchantCategoryRule = createSelector([getTransactionsToRecategorizeOnMerchantCategoryRule, getCategoryFromProps, getPreviousCategoryFromProps], function (transactions, category, previousCategory) {
  var _categoriesWithDates;

  var categoriesWithDates = (_categoriesWithDates = {}, _defineProperty(_categoriesWithDates, category, {}), _defineProperty(_categoriesWithDates, previousCategory, {}), _categoriesWithDates);
  var newDayInEndMonth;
  var newDayInStartMonth;

  _each(transactions, function (transaction) {
    var date = moment(transaction.date).date(1).format(DATE_FORMAT.STANDARD);

    var previousDayInStartMonth = _get(categoriesWithDates, "".concat(transaction.category, ".dayInStartMonth"));

    var previousDayInEndMonth = _get(categoriesWithDates, "".concat(transaction.category, ".dayInEndMonth"));

    newDayInStartMonth = previousDayInStartMonth;
    newDayInEndMonth = previousDayInEndMonth;

    if (!previousDayInStartMonth || moment(date).isBefore(previousDayInStartMonth, 'month')) {
      newDayInStartMonth = date;
    }

    if (!previousDayInEndMonth || moment(date).isAfter(previousDayInEndMonth, 'month')) {
      newDayInEndMonth = date;
    } // save the start and end dates for the source and destination categories


    categoriesWithDates[transaction.category] = {
      dayInStartMonth: newDayInStartMonth,
      dayInEndMonth: newDayInEndMonth
    };

    if (transaction.previousCategory) {
      categoriesWithDates[transaction.previousCategory] = {
        dayInStartMonth: newDayInStartMonth,
        dayInEndMonth: newDayInEndMonth
      };
    }
  });

  if (_isEmpty(categoriesWithDates[previousCategory])) {
    // if there are no remaining transactions in a particular category after merchant recategorizing away from it,
    // we still need a date range for rollup calculations even though we expect the sum to be 0, so just re-use the
    // same date range as the new category
    categoriesWithDates[previousCategory] = _objectSpread({}, categoriesWithDates[category]);
  }

  return categoriesWithDates;
});
export var makeGetTransactionById = function makeGetTransactionById() {
  return createSelector([getAllTransactionsById, getTransactionIdFromProps], function (allTransactionsById, transactionId) {
    return allTransactionsById[transactionId];
  });
};
export var getTransactionRollupsByCategory = function getTransactionRollupsByCategory(identity, props) {
  var date = getDateFromProps(identity, props);
  var firstDayInCurrentMonth = moment(date).startOf('month').format(DATE_FORMAT.STANDARD);
  return _get(identity, "yodlee.transactions.categoryRollups[".concat(firstDayInCurrentMonth, "]"));
};
export var getDailyTransactionSpending = function getDailyTransactionSpending(identity) {
  return _get(identity, "yodlee.transactions.dailyRollups.".concat(CashFlowCategories.SPENDING));
};
var getCurrentMonthDailyTransactionSpending = createSelector([getDailyTransactionSpending, getDateFromProps], function (dailyTransactionSpending, date) {
  var dayInCurrentMonth = moment(date).format(DATE_FORMAT.STANDARD);
  var currentMonthWindowKey = yodleeUtils.createMonthWindowKey(dayInCurrentMonth);
  return _get(dailyTransactionSpending, currentMonthWindowKey);
});
var getPreviousMonthDailyTransactionSpending = createSelector([getDailyTransactionSpending, getDateFromProps], function (dailyTransactionSpending, date) {
  var dayInPreviousMonth = moment(date).subtract('1', 'month').format(DATE_FORMAT.STANDARD);
  var currentMonthWindowKey = yodleeUtils.createMonthWindowKey(dayInPreviousMonth);
  return _get(dailyTransactionSpending, currentMonthWindowKey);
});
export var getCurrentMonthDailyCumulativeSpending = createSelector([getCurrentMonthDailyTransactionSpending, getDateFromProps], function (currentMonthSpending, date) {
  if (!currentMonthSpending) {
    return null;
  }

  var dayInCurrentMonth = moment(date).format(DATE_FORMAT.STANDARD);

  var currentMonthSpendingWithDates = _reduce(currentMonthSpending, function (acc, amount, dayInMonth) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, moment(dayInCurrentMonth).date(dayInMonth).format(DATE_FORMAT.STANDARD), amount));
  }, {});

  return yodleeUtils.getMonthSpendingDataByDate(currentMonthSpendingWithDates);
});
export var getPreviousMonthDailyCumulativeSpending = createSelector([getPreviousMonthDailyTransactionSpending, getDateFromProps], function (previousMonthSpending, date) {
  if (!previousMonthSpending) {
    return null;
  }

  var dayInPreviousMonth = moment(date).subtract('1', 'month').format(DATE_FORMAT.STANDARD);

  var previousMonthSpendingWithDates = _reduce(previousMonthSpending, function (acc, amount, dayInMonth) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, moment(dayInPreviousMonth).date(dayInMonth).format(DATE_FORMAT.STANDARD), amount));
  }, {});

  return yodleeUtils.getMonthSpendingDataByDate(previousMonthSpendingWithDates);
});
export var getDailyCumulativeSpendingForWindow = createSelector([getDailyTransactionSpending, getStartDateFromProps, getEndDateFromProps], function (dailyTransactionSpending, startDate, endDate) {
  var windowKey = yodleeUtils.createWindowKey(startDate, endDate);

  var averageDailySpending = _get(dailyTransactionSpending, windowKey);

  return yodleeUtils.getMonthSpendingDataByDay(averageDailySpending);
});
export var getViewFilter = function getViewFilter(identity) {
  return _get(identity, 'yodlee.transactions.viewFilter');
};
export var getTransactionsView = function getTransactionsView(identity) {
  return identity.yodlee.transactions.viewList;
};
export var getHasTransactions = function getHasTransactions(identity) {
  return getHasSyncedTransactions(identity);
};
export var getCanShowMoreTransactions = function getCanShowMoreTransactions(identity) {
  if (!getHasTransactions(identity)) {
    return false;
  }

  var viewFilter = getViewFilter(identity);
  var data = getTransactionData(identity, viewFilter);

  if (!data) {
    return true;
  }

  if (identity.yodlee.transactions.viewList.length < data.transactions.length) {
    return true;
  }

  if (!data.lastPageReached) {
    return true;
  }

  return false;
};
export var isBulkLoadingInProgress = function isBulkLoadingInProgress(identity) {
  return _get(identity, 'yodlee.transactions.bulkLoadingInProgress');
}; // if there are not transactions for the current filter and the last page is reached then
// user has no transactions to display for this filter

export var getHasNoTransactionsForCurrentFilter = function getHasNoTransactionsForCurrentFilter(identity) {
  var viewFilter = getViewFilter(identity);
  var transactionData = getTransactionData(identity, viewFilter);
  var hasNoTransactions = _get(transactionData, 'transactions.length', 0) === 0;

  var lastPageReached = _get(transactionData, 'lastPageReached', false);

  if (hasNoTransactions && lastPageReached) return true;
  return false;
};
/**
 * Returns an object containing the sum of spending and earning of all transactions for the month.
 *
 * @param {object} identity The state of the redux identity reducer.
 * @param {object} month A Date object representing the desired month
 * @param {object} filter Transactions filter. Defaults to current viewFilter.
 *
 * @return {object} Rollup for the (optionally filtered) transactions
 * */

export var getTransactionRollupSum = function getTransactionRollupSum(identity, month, filter) {
  var firstOfMonth = moment(month).date(1).format(DATE_FORMAT.STANDARD);
  var transactionData = getTransactionData(identity, filter || getViewFilter(identity));
  return _get(transactionData, "monthRollups[".concat(firstOfMonth, "]"));
};
export var getTransactionRollupsForFilter = function getTransactionRollupsForFilter(identity) {
  var viewFilter = getViewFilter(identity);
  var transactionData = getTransactionData(identity, viewFilter);
  return _get(transactionData, 'monthRollups');
};
export var getTransactionRollupSumForEverything = function getTransactionRollupSumForEverything(identity, month) {
  var firstOfMonth = moment(month).date(1).format(DATE_FORMAT.STANDARD);
  var transactionData = getTransactionData(identity, {});
  return _get(transactionData, "monthRollups[".concat(firstOfMonth, "]"));
};
export var getSumLoanBalances = function getSumLoanBalances(identity) {
  return (_get(identity, 'profiles.yodlee_profile.sum_loan_balances') || 0) * -1;
};
export var getYodleeTOSAcknowledged = function getYodleeTOSAcknowledged(identity) {
  var tosAcks = _get(identity, 'profiles.terms_of_service_profile.tos_acknowledgements');

  return _some(tosAcks, function (ack) {
    if (_get(ack, 'version') === CURRENT_YODLEE_TOS_VERSION && _get(ack, 'type') === 'YODLEE') {
      return true;
    }
  });
};
export var getAccountNameProperties = function getAccountNameProperties(account) {
  var providerName = _get(account, 'provider_name', '');

  var accountName = _get(account, 'account_name', '');

  var accountNumberLast4 = _get(account, 'account_number_last_4', '');

  return {
    providerName: providerName,
    accountName: accountName,
    accountNumberLast4: accountNumberLast4
  };
};
export var getAllAccountNameProperties = function getAllAccountNameProperties(identity) {
  var accountProperties = {};
  var providerAccounts = getAllProviderAccounts(identity);

  _each(providerAccounts, function (providerAccount) {
    var accounts = _get(providerAccount, 'accounts', []);

    _each(accounts, function (account) {
      if (!accountProperties[account.id]) {
        accountProperties[account.id] = getAccountNameProperties(account);
      }
    });
  });

  return accountProperties;
};
export var getAccountsByInvestingType = function getAccountsByInvestingType(identity, type) {
  return getAllFinancialAccounts(identity).filter(function (account) {
    return _get(account, 'extra_data.investingAccountType') === type;
  });
};
export var has401k = function has401k(identity) {
  return getAccountsByInvestingType(identity, 'current_401k_balance').length > 0;
};
export var hasRothIRA = function hasRothIRA(identity) {
  return getAccountsByInvestingType(identity, 'current_roth_ira_balance').length > 0;
};
export var hasIRA = function hasIRA(identity) {
  return getAccountsByInvestingType(identity, 'current_ira_balance').length > 0;
};
/**
 * @deprecated Use {@link getSpendingCategoryV2Data} instead.
 */

export var getSpendingCategoryData = createSelector([getTransactionRollupsByCategory], function (transactionRollupsByCategory) {
  var transactionCategoriesData = _pick(transactionRollupsByCategory, [TransactionCategories.BILL, TransactionCategories.TRANSPORT, TransactionCategories.FOOD, TransactionCategories.OTHER, TransactionCategories.FEES]);

  var unsortedData = _reduce(transactionCategoriesData, function (acc, val, key) {
    acc.push({
      category: key,
      value: val
    });
    return acc;
  }, []);

  return unsortedData.sort(yodleeUtils.compareCategoriesDescending);
});
export var getCategoryWindowRollups = function getCategoryWindowRollups(identity) {
  return _get(identity, 'yodlee.transactions.categoryWindowRollups');
};
export var getCategoryRollupsInWindow = createSelector([getCategoryWindowRollups, getStartDateFromProps, getEndDateFromProps], function (categoryRollupWindows, startDate, endDate) {
  return _get(categoryRollupWindows, "".concat(startDate, "-").concat(endDate));
});
/**
 * A sorted array with the category spending data needed for the spending
 * category tile. Takes the rounded value for each category rollup and returns
 * a max of 4 objects, where the fourth object represents the sum of the lowest
 * spending categories.
 *
 * @return {Array} Top spending categories
 */

export var getSpendingCategoryV2Data = createSelector([getTransactionRollupsByCategory, getCategoryRollupsInWindow], function (transactionRollupsByCategory, categoryWindowRollups) {
  var categoryRollupData = categoryWindowRollups || transactionRollupsByCategory;

  var spendingCategoriesData = _pick(categoryRollupData, [TransactionCategoriesV2.ENTERTAINMENT, TransactionCategoriesV2.FEES, TransactionCategoriesV2.GROCERIES, TransactionCategoriesV2.HEALTH, TransactionCategoriesV2.HOUSING, TransactionCategoriesV2.OTHER, TransactionCategoriesV2.RESTAURANTS, TransactionCategoriesV2.SHOPPING, TransactionCategoriesV2.TRANSPORT, TransactionCategoriesV2.TRAVEL, TransactionCategoriesV2.UTILITIES]);

  var unsortedData = _reduce(spendingCategoriesData, function (acc, val, key) {
    // round value and make sure it is non-negative
    acc.push({
      category: key,
      value: _max([_round(val), 0])
    });
    return acc;
  }, []);

  return yodleeUtils.sortSpendingCategoryData(unsortedData);
});
export var getCashFlowMonthlyRollups = function getCashFlowMonthlyRollups(identity) {
  return _get(identity, 'yodlee.transactions.cashFlowRollups.monthly');
};
export var getCurrentMonthEarning = function getCurrentMonthEarning(identity, props) {
  var date = getDateFromProps(identity, props);
  var monthlyRollups = getCashFlowMonthlyRollups(identity);
  var firstOfMonth = moment(date).startOf('month').format(DATE_FORMAT.STANDARD);
  return _get(monthlyRollups, "".concat(firstOfMonth, ".").concat(CashFlowCategories.EARNING));
};
export var getCurrentMonthSpending = function getCurrentMonthSpending(identity, props) {
  var date = getDateFromProps(identity, props);
  var rollupSum = getTransactionRollupSum(identity, moment(date), {});
  var monthlyRollups = getCashFlowMonthlyRollups(identity);
  var firstOfMonth = moment(date).startOf('month').format(DATE_FORMAT.STANDARD);
  return _get(monthlyRollups, "".concat(firstOfMonth, ".").concat(CashFlowCategories.SPENDING)) || _get(rollupSum, 'sum');
};
export var getSpendingInsAndOutsData = createSelector([getCurrentMonthEarning, getCurrentMonthSpending], function (currentMonthEarning, currentMonthSpending) {
  return [{
    x: CashFlowCategories.EARNING,
    y: currentMonthEarning
  }, {
    x: CashFlowCategories.SPENDING,
    y: currentMonthSpending
  }];
});
export var getAllBills = function getAllBills(identity) {
  return _get(identity, 'yodlee.transactions.buckets.category.bill.transactions');
};
export var getTransactionsResultsSetToken = function getTransactionsResultsSetToken(identity) {
  return _get(identity, 'yodlee.transactions.resultsSetToken');
};
export var getTopMerchants = function getTopMerchants(identity) {
  return _get(identity, 'yodlee.transactions.topMerchants');
};
export var getTopMerchantsInWindow = createSelector([getTopMerchants, getStartDateFromProps, getEndDateFromProps], function (topMerchants, startDate, endDate) {
  var merchants = _get(topMerchants, "window.".concat(startDate, "-").concat(endDate));

  if (!merchants) {
    return null;
  } // filter out merchants with null canonical_merchant_names


  return _filter(merchants, 'canonical_merchant_name');
});
/**
 * @deprecated Unnecessary selector factory. Use `getTopMerchantsInWindow` instead.
 */

export var makeGetTopMerchantsInWindow = function makeGetTopMerchantsInWindow(startDate, endDate) {
  return createSelector([function (identity) {
    return getTopMerchantsInWindow(identity, {
      startDate: startDate,
      endDate: endDate
    });
  }], // filter out merchants with null canonical_merchant_names
  function (merchants) {
    return _filter(merchants, 'canonical_merchant_name');
  });
};
export var getSortedSpendingCategoryRollupsInWindow = createSelector([getCategoryRollupsInWindow], function (categoryRollups) {
  var spendingCategoryRollups = _reduce(categoryRollups, function (acc, amount, category) {
    return yodleeUtils.isSpendingTransactionCategory(category) ? [].concat(_toConsumableArray(acc), [{
      category: category,
      amount: amount
    }]) : acc;
  }, []);

  return _reverse(_sortBy(spendingCategoryRollups, 'amount'));
});
export var getMonthlyEstimates = function getMonthlyEstimates(identity) {
  return _get(identity, 'yodlee.transactions.monthlyEstimates');
};
/**
 * @deprecated Use {@link getMonthlyEstimatedEarning}
 */

export var getMonthlyEstimatedIncome = function getMonthlyEstimatedIncome(identity, dateInTargetMonth) {
  var firstDayOfMonth = moment(dateInTargetMonth).date(1).format(DATE_FORMAT.STANDARD);

  var monthlyNetIncome = _get(identity, 'profiles.financial_profile.monthly_net_income');

  var annualIncome = _get(identity, 'profiles.financial_profile.annual_income');

  if (!_isNil(monthlyNetIncome)) {
    return monthlyNetIncome;
  }

  if (!_isNil(annualIncome)) {
    return _round(annualIncome / 12);
  }

  return _get(identity, "yodlee.transactions.monthlyEstimates[".concat(firstDayOfMonth, "].income"));
};

var getItemLimitFromProps = function getItemLimitFromProps(state, props) {
  return props.itemLimit;
};

export var getUserReportedMonthlyEarning = createSelector([getIncome, getMonthlyNetIncome], function (annualIncome, monthlyNetIncome) {
  if (!_isNil(monthlyNetIncome)) {
    return monthlyNetIncome;
  }

  if (!_isNil(annualIncome)) {
    return _round(annualIncome / 12);
  }

  return null;
});
export var getMonthlyProjectedEarning = createSelector([getMonthlyEstimates, getDateFromProps], function (monthlyEstimates, dateInTargetMonth) {
  var firstDayOfMonth = moment(dateInTargetMonth).date(1).format(DATE_FORMAT.STANDARD);
  return _get(monthlyEstimates, [firstDayOfMonth, CashFlowCategories.EARNING]);
});
export var getMonthlyEstimatedEarning = createSelector([getUserPreferredIncomeEstimateSource, getUserReportedMonthlyEarning, getMonthlyProjectedEarning], function (userPreferredSource, userReportedEarning, projectedEarning) {
  // userPreferredSource is null if the user hasn't specified a preference yet
  if (userPreferredSource === UserPreferredIncomeEstimateSources.USER_REPORTED) {
    return userReportedEarning;
  }

  if (userPreferredSource === UserPreferredIncomeEstimateSources.PROJECTED) {
    return projectedEarning;
  }

  if (!_isNil(userReportedEarning)) {
    return userReportedEarning;
  }

  return projectedEarning;
});
/**
 * @param identity
 * @param {string|number} id Either providerAccountStateId (string) or providerAccountId (number)
 *
 * @return {boolean}
 */

export var isProviderAccountDeleting = function isProviderAccountDeleting(identity, id) {
  return _some(_get(identity, 'requests.deleteProviderAccount.pendingRequests'), function (_ref2) {
    var providerAccountStateId = _ref2.providerAccountStateId,
        providerAccountId = _ref2.providerAccountId;
    return providerAccountStateId === id || providerAccountId === id;
  });
};
/**
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 */

export var makeGetAllPredictedBills = function makeGetAllPredictedBills() {
  return createSelector([getAllBills, getDateFromProps], yodleeUtils.createPredictedBills);
};
/**
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 */

export var makeGetFuturePredictedBills = function makeGetFuturePredictedBills() {
  return createSelector([getAllBills, getDateFromProps], yodleeUtils.getFuturePredictedBills);
};
/**
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 */

export var makeGetPastPredictedBills = function makeGetPastPredictedBills() {
  return createSelector([getAllBills, getDateFromProps], yodleeUtils.getPastPredictedBills);
};
/**
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 */

export var makeGetPredictedBillsTileList = function makeGetPredictedBillsTileList() {
  return createSelector([getAllBills, getDateFromProps, getItemLimitFromProps], function (bills, date, itemLimit) {
    var pastPredictedBills = yodleeUtils.getPastPredictedBills(bills, date);
    var futurePredictedBills = yodleeUtils.getFuturePredictedBills(bills, date);
    return _slice(_concat(_reverse(_slice(pastPredictedBills, 0, itemLimit)), _reverse(_slice(futurePredictedBills, itemLimit * -1))), itemLimit * -1);
  });
};
/**
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 */

export var makeGetPredictedBillsTotal = function makeGetPredictedBillsTotal() {
  return createSelector([getAllBills, getDateFromProps], function (bills, date) {
    var predictedBills = yodleeUtils.getFuturePredictedBills(bills, date);
    return yodleeUtils.sumTransactionAmounts(predictedBills);
  });
};
export var getYodleeTopTakeaways = function getYodleeTopTakeaways(identity) {
  return _get(identity, 'yodlee.topTakeaways');
};
export var getIsAccountIAVVerified = function getIsAccountIAVVerified(identity, account) {
  return _get(getProviderAccountForAccount(identity, account), 'provider_account_state.iav_verified', false);
};
export var getAllProviderAccountsWithoutAccounts = createSelector([getAllProviderAccounts], function () {
  var providerAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return providerAccounts.filter(function (providerAccount) {
    return yodleeUtils.getAllAccountsForProviderAccount(providerAccount).length === 0;
  });
});
export var getAllActiveProviderAccounts = createSelector([getAllProviderAccounts], function (providerAccounts) {
  return _filter(providerAccounts, function (providerAccount) {
    return yodleeUtils.getIsProviderAccountInActiveState(providerAccount);
  });
});
export var getAllUserActionProviderAccounts = createSelector([getAllProviderAccounts], function (providerAccounts) {
  return _filter(providerAccounts, yodleeUtils.getIsUserActionRequired);
});
export var getAllUserActionProviderAccountsWithoutAccounts = createSelector([getAllUserActionProviderAccounts, getAllProviderAccountsWithoutAccounts], function (userActionProviderAccounts, providerAccountsWithoutAccounts) {
  return _intersection(userActionProviderAccounts, providerAccountsWithoutAccounts);
});
export var getAllProviderAccountsSyncingOrRefreshing = createSelector([getAllProviderAccounts], function (providerAccounts) {
  return _filter(providerAccounts, yodleeUtils.getIsProviderAccountSyncingOrRefreshing);
});
export var getAllSyncingOrRefreshingProviderAccountsWithoutAccounts = createSelector([getAllProviderAccountsSyncingOrRefreshing, getAllProviderAccountsWithoutAccounts], function (syncingOrRefreshingProviderAccounts, providerAccountsWithoutAccounts) {
  return _intersection(syncingOrRefreshingProviderAccounts, providerAccountsWithoutAccounts);
}); // Returns a list of all linked Yodlee provider accounts (i.e. financial institutions)
// that support IAV.

export var getAllIAVEnabledProviderAccounts = createSelector([getAllProviderAccounts], function () {
  var allProviderAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return allProviderAccounts.filter(function (providerAccount) {
    return yodleeUtils.getIsProviderAccountIAVEnabled(providerAccount);
  });
});
export var getAllIAVVerifiedProviderAccounts = createSelector([getAllProviderAccounts], function () {
  var allProviderAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return allProviderAccounts.filter(function (providerAccount) {
    return yodleeUtils.getIsProviderAccountIAVVerified(providerAccount);
  });
}); // Returns a list of all Provider Accounts that NerdWallet has deemed worthy

export var getAllAdminActivatedProviderAccounts = createSelector([getAllProviderAccounts], function () {
  var allProviderAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return allProviderAccounts.filter(function (providerAccount) {
    return !yodleeUtils.getIsProviderAccountAdminDeactivated(providerAccount);
  });
});
/**
 * A valid provider account is a provider account that could potentially be visible in a "transfer
 * experience UI" without considering anything related to its accounts.
 *
 * Transfer experience UIs include (currently):
 * 1. Money Transfer
 * 2. IAO (integrated account opening)
 *
 * A valid provider accounts is:
 * 1. A provider account that is admin activated
 * 2. A provider account that is IAV enabled
 */

export var getAllValidTransferProviderAccounts = createSelector([getAllAdminActivatedProviderAccounts, getAllIAVEnabledProviderAccounts], function (adminActivatedProviderAccounts, IAVEnabledProviderAccounts) {
  return _intersection(adminActivatedProviderAccounts, IAVEnabledProviderAccounts);
}); // IAV-verifiable provider accounts are provider accounts that:
// 1. Have IAV enabled providers
// 2. Have NerdWallet admin activated providers
// 3. Have not already been IAV verified
// 4. Are active provider accounts

export var getAllProviderAccountsToIAVVerify = createSelector([getAllValidTransferProviderAccounts, getAllActiveProviderAccounts, getAllIAVVerifiedProviderAccounts], function (validTransferProviderAccounts, activeProviderAccounts, IAVVerifiedProviderAccounts) {
  return _difference(_intersection(validTransferProviderAccounts, activeProviderAccounts), IAVVerifiedProviderAccounts);
}); // Fetches a list of all linked accounts from all linked providers that
// support IAV.

export var getAllIAVEnabledAccounts = createSelector([getAllIAVEnabledProviderAccounts], function (IAVEnabledProviderAccounts) {
  return _compact(_flatMap(IAVEnabledProviderAccounts, function (provider) {
    return provider.accounts;
  }));
}); // Fetches a list of all linked accounts from all linked providers that
// have verified with IAV.

export var getAllIAVVerifiedAccounts = createSelector([getAllIAVVerifiedProviderAccounts], function (IAVVerifiedProviderAccounts) {
  return _compact(_flatMap(IAVVerifiedProviderAccounts, function (provider) {
    return provider.accounts;
  }));
});
export var getAllActiveAccounts = createSelector([getAllActiveProviderAccounts], function (activeProviderAccounts) {
  return activeProviderAccounts.flatMap(yodleeUtils.getAllAccountsForProviderAccount);
});
export var getAllAdminActivatedAccounts = createSelector([getAllAdminActivatedProviderAccounts], function (adminActivatedProviderAccounts) {
  return _compact(_flatMap(adminActivatedProviderAccounts, function (provider) {
    return provider.accounts;
  }));
});
export var getAllLoanAccounts = createSelector([getAccountsGroupedByType], function (accountsGroupedByType) {
  return _get(accountsGroupedByType, YodleeAccountTypes.LOAN, []);
});
export var getAllCreditCardAccounts = createSelector([getAccountsGroupedByType], function (accountsGroupedByType) {
  return _get(accountsGroupedByType, YodleeAccountTypes.CREDIT_CARD, []);
});
export var getAllInvestmentAccounts = createSelector([getAccountsGroupedByType], function (accountsGroupedByType) {
  return _get(accountsGroupedByType, YodleeAccountTypes.INVESTMENT, []);
});
export var getAllBankAccounts = createSelector([getAccountsGroupedByType], function (accountsGroupedByType) {
  return _get(accountsGroupedByType, YodleeAccountTypes.BANK, []);
});
export var getAllLoanAccountsGroupedBySubtype = createSelector([getAllLoanAccounts], function (loanAccounts) {
  return _groupBy(loanAccounts, 'loan_account_type');
});
export var getAllMortgageAccounts = createSelector([getAllLoanAccountsGroupedBySubtype], function (loanAccountsGroups) {
  return _get(loanAccountsGroups, YodleeAccountSubTypes.MORTGAGE, []);
});
export var getAllBankAccountsGroupedBySubtype = createSelector([getAllBankAccounts], function (bankAccounts) {
  return _groupBy(bankAccounts, 'bank_account_type');
});
export var getAllCheckingAccounts = createSelector([getAllBankAccountsGroupedBySubtype], function (bankAccountsGroups) {
  return _get(bankAccountsGroups, YodleeAccountSubTypes.CHECKING, []);
});
export var getAllSavingsAccounts = createSelector([getAllBankAccountsGroupedBySubtype], function (bankAccountsGroups) {
  return _get(bankAccountsGroups, YodleeAccountSubTypes.SAVINGS, []);
});
export var getAllMoneyMarketAccounts = createSelector([getAllBankAccountsGroupedBySubtype], function (bankAccountsGroups) {
  return _get(bankAccountsGroups, YodleeAccountSubTypes.MONEY_MARKET, []);
});
export var getAllSavingsAndMoneyMarketAccounts = createSelector([getAllSavingsAccounts, getAllMoneyMarketAccounts], function (savingsAccounts, moneyMarketAccounts) {
  return _union(savingsAccounts, moneyMarketAccounts);
});
/**
 * A valid transfer account is one that is potentially selectable in a transfer UI, eligible/ineligible
 * section of the UI without taking into account the further eligibility filtering that will be performed.
 * Current valid accounts are:
 * 1. A checkings/savings/money market account
 * 2. An active account
 *
 * Current products that utilize this definition are:
 * 1. Money Transfer
 * 2. IAO
 */

export var getAllValidTransferAccounts = createSelector([getAllCheckingAccounts, getAllSavingsAndMoneyMarketAccounts, getAllActiveAccounts], function (checkingAccounts, savingsAndMoneyMarketAccounts, activeAccounts) {
  return _intersection(_union(checkingAccounts, savingsAndMoneyMarketAccounts), activeAccounts);
}); // A valid transfer checking account is any account that could potentially be shown in the
// from account section, prior to any eligibility checks that will filter some out.

export var getAllValidTransferCheckingAccounts = createSelector([getAllValidTransferAccounts, getAllCheckingAccounts], function (validTransferAccounts, checkingAccounts) {
  return _intersection(validTransferAccounts, checkingAccounts);
});
export var getAllValidTransferSavingsAndMoneyMarketAccounts = createSelector([getAllValidTransferAccounts, getAllSavingsAndMoneyMarketAccounts], function (validTransferAccounts, savingsAndMoneyMarketAccount) {
  return _intersection(validTransferAccounts, savingsAndMoneyMarketAccount);
});
/* These currently are only used in the Saving experience on the Mobile App */

export var getAllNWCheckingAccounts = createSelector([getAllFinancialAccounts], function (accounts) {
  return accounts.filter(function (account) {
    return yodleeUtils.getIsNWCheckingAccount(account);
  });
});
export var getAllNWSavingsAccounts = createSelector([getAllFinancialAccounts], function (accounts) {
  return accounts.filter(function (account) {
    return yodleeUtils.getIsNWSavingsAccount(account);
  });
});
export var getAllNWInvestmentAccounts = createSelector([getAllFinancialAccounts], function (accounts) {
  return accounts.filter(function (account) {
    return yodleeUtils.getIsNWInvestmentAccount(account);
  });
});
export var getAllNWRetirementAccounts = createSelector([getAllFinancialAccounts], function (accounts) {
  return accounts.filter(function (account) {
    return yodleeUtils.getIsNWRetirementAccount(account);
  });
});
export var getAllCSIRAccounts = createSelector([getAllNWCheckingAccounts, getAllNWSavingsAccounts, getAllNWInvestmentAccounts, getAllNWRetirementAccounts], function (checkingAccounts, savingsAccounts, investmentAccounts, retirementAccounts) {
  return [].concat(_toConsumableArray(checkingAccounts), _toConsumableArray(savingsAccounts), _toConsumableArray(investmentAccounts), _toConsumableArray(retirementAccounts));
});
export var getHasCSIRAccounts = createSelector([getAllCSIRAccounts], function (csirAccounts) {
  return !_isEmpty(csirAccounts);
}); // This is generally used to determine the accounts for which we don't want to include Checking,
// e.g. transfers into Checking accounts don't count as contributions towards a Saving goal

export var getHasNonNWCheckingCSIRAccounts = createSelector([getAllCSIRAccounts, getAllNWCheckingAccounts], function (csirAccounts, checkingAccounts) {
  return _difference(csirAccounts, checkingAccounts).length > 0;
});
export var getAllAccountsWithTransactions = createSelector([getAllFinancialAccounts], function (accounts) {
  return _filter(accounts, yodleeUtils.getHasAccountSyncedTransactions);
});
export var getAllAccountsWithoutTransactions = createSelector([getAllFinancialAccounts], function (accounts) {
  return _filter(accounts, function (account) {
    return !yodleeUtils.getHasAccountSyncedTransactions(account);
  });
});
export var getAllAccountsWithBalances = createSelector([getAllFinancialAccounts], function (accounts) {
  return _filter(accounts, yodleeUtils.getHasAccountSyncedBalances);
});
export var getAllAccountsWithBalancesAndTransactions = createSelector([getAllFinancialAccounts], function (accounts) {
  return _filter(accounts, yodleeUtils.getHasAccountSyncedBalancesAndTransactions);
});
export var getAllActiveAccountsWithBalances = createSelector([getAllAccountsWithBalances, getAllActiveAccounts], function (accountsWithBalances, activeAccounts) {
  return _intersection(accountsWithBalances, activeAccounts);
}); // A fully active account is an account that:
// 1. Is an active account
// 2. Is an account with balances and transactions

export var getAllFullyActivatedAccounts = createSelector([getAllAccountsWithBalancesAndTransactions, getAllActiveAccounts], function (accountsWithBalancesAndTransactions, activeAccounts) {
  return _intersection(accountsWithBalancesAndTransactions, activeAccounts);
});
export var getAllCSIRAccountsWithBalancesAndTransactions = createSelector([getAllCSIRAccounts, getAllAccountsWithBalancesAndTransactions], function (csirAccounts, accountsWIthBalancesAndTransactions) {
  return _intersection(csirAccounts, accountsWIthBalancesAndTransactions);
}); // A fully active CSIR account is an account that:
// 1. Is an active account
// 2. Is a CSIR account with balances and transactions

export var getAllFullyActivatedCSIRAccounts = createSelector([getAllCSIRAccountsWithBalancesAndTransactions, getAllActiveAccounts], function (csirAccounts, activeAccounts) {
  return _intersection(csirAccounts, activeAccounts);
});
var getAllAccounts = createSelector([getAllProviderAccounts], function (allProviderAccounts) {
  return _flatMap(allProviderAccounts, function (provider) {
    return provider.accounts;
  });
});

var getAccountById = function getAccountById(identity, accountId) {
  var allAccounts = getAllAccounts(identity);
  return allAccounts.find(function (acct) {
    return acct.id === accountId;
  });
};

export var getIsRefreshSupportedForAccountId = function getIsRefreshSupportedForAccountId(identity, accountId) {
  var account = getAccountById(identity, accountId);

  if (!account) {
    return false;
  }

  var providerAccount = getProviderAccountForAccount(identity, account);
  return yodleeUtils.getPrimarySourceFromProviderAccount(providerAccount) !== FINANCIAL_PORTAL_PRIMARY_SOURCES.PLAID;
};
export var hasProviderAccountStateFailedAutoRefresh = function hasProviderAccountStateFailedAutoRefresh(identity, providerAccountStateId) {
  return !!identity.yodlee.autoRefresh.failures[providerAccountStateId];
}; // Get provider details for the currently selected provider id

export var getSelectedProviderDetails = function getSelectedProviderDetails(identity) {
  var _identity$yodlee3, _identity$yodlee3$pro;

  var providerId = getSelectedProviderId(identity);
  return (_identity$yodlee3 = identity.yodlee) === null || _identity$yodlee3 === void 0 ? void 0 : (_identity$yodlee3$pro = _identity$yodlee3.providers) === null || _identity$yodlee3$pro === void 0 ? void 0 : _identity$yodlee3$pro[providerId];
};
export var getSelectedProviderAuthType = function getSelectedProviderAuthType(identity) {
  return _get(getSelectedProviderDetails(identity), 'provider_details.authType');
}; // Boolean whether to make an api request to get provider details. Conditions: no current request
// for provider id and we don't have the details already.

export var getShouldFetchProviderDetails = createSelector(getSelectedProviderId, getSelectedProviderDetails, getIsFetchingSelectedProviderDetails, function (selectedProviderId, providerDetails, hasPendingRequest) {
  return selectedProviderId && !providerDetails && !hasPendingRequest;
});